import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=8cc61cfe"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"
import style0 from "./AdminApp.vue?vue&type=style&index=0&id=8cc61cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports